import { render, staticRenderFns } from "./ShortsDialog.vue?vue&type=template&id=db0d4908&scoped=true"
import script from "./ShortsDialog.vue?vue&type=script&lang=js"
export * from "./ShortsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0d4908",
  null
  
)

export default component.exports